import { makeStyles } from '@rbx/ui';

const useEndpointStyles = makeStyles()(() => ({
  marginBottom24: {
    marginBottom: 24,
  },
  resourcePathItem: {
    wordBreak: 'break-all',
    whiteSpace: 'normal',
  },
  marginTop24: {
    marginTop: 24,
  },
  marginTop64: {
    marginTop: 64,
  },
  marginTop40: {
    marginTop: 40,
  },
  marginTop48: {
    marginTop: 48,
  },
  marginBottom8: {
    marginBottom: 8,
  },
  block: {
    display: 'block',
  },
  scopes: {
    marginTop: 24,
    width: '100%',
  },
  scopesItem: {
    display: 'inline-block',
    marginRight: 8,
    marginBottom: 8,
  },
  width100: {
    width: '100%',
  },
  breakWord: {
    wordBreak: 'break-all',
  },
  tags: {
    display: 'inline',
    marginTop: 0,
    marginLeft: 12,
    fontSize: 16,
    fontWeight: 300,
    verticalAlign: 'middle',
  },
}));

export default useEndpointStyles;
